"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _find = _interopRequireDefault(require("lodash/find"));

var _browserHelpers = require("@flowio/browser-helpers");

var _utilities = require("../utilities");

var _dropdown_component = _interopRequireDefault(require("../dropdown_component"));

// @ts-check

/** @typedef {import('../types').CountryOption} CountryOption */

/** @typedef {import('../types').DropdownOptions} DropdownOptions */

/** @typedef {import('../types').DropdownOptionConfig} DropdownOptionConfig */

/** @typedef {import('../types').CountryPickerOptions} CountryPickerOptions */
var CountryPickerDropdown = /*#__PURE__*/function () {
  (0, _createClass2["default"])(CountryPickerDropdown, null, [{
    key: "create",
    value: function create(
    /** @type {CountryPickerOptions} */
    optionsObj) {
      return Promise.resolve(new CountryPickerDropdown(optionsObj));
    }
  }]);

  function CountryPickerDropdown(
  /** @type {CountryPickerOptions} */
  optionsObj) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, CountryPickerDropdown);
    (0, _defineProperty2["default"])(this, "initDomElements", function () {
      _this.countryPickerMenu = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-dropdown-menu'
      });
      _this.countryPickerTrigger = (0, _utilities.createDomElement)('span', {
        "class": 'flow-country-picker-dropdown-trigger'
      });
    });
    var displayDefaultCurrency = optionsObj.displayDefaultCurrency;
    this.open = false;
    this.options = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, (0, _utilities.getDefaultCountryPickerOptions)(displayDefaultCurrency)), optionsObj);
    this.initDomElements();
    this.createCountryPickerDropdown();
  }

  (0, _createClass2["default"])(CountryPickerDropdown, [{
    key: "toggleDropdown",
    value: function toggleDropdown() {
      if (this.open) {
        (0, _browserHelpers.removeClass)(this.countryPickerMenu, 'flow-country-picker-show');
        (0, _browserHelpers.removeClass)(this.countryPickerTrigger, 'flow-country-picker-open');
        this.backdrop.parentElement.removeChild(this.backdrop);
      } else {
        this.backdrop = (0, _utilities.createDomElement)('div', {
          "class": 'flow-country-picker-dropdown-backdrop',
          id: 'countryPickerBackdrop'
        });
        (0, _browserHelpers.addEvent)(this.backdrop, 'click', this.toggleDropdown.bind(this));
        document.body.appendChild(this.backdrop);
        (0, _browserHelpers.addClass)(this.countryPickerMenu, 'flow-country-picker-show');
        (0, _browserHelpers.addClass)(this.countryPickerTrigger, 'flow-country-picker-open');
      }

      this.open = !this.open;
    }
  }, {
    key: "createCountryPickerDropdown",
    value: function createCountryPickerDropdown() {
      var _this2 = this;

      var countryPicker = document.getElementById(this.options.containerId);
      this.session = JSON.parse(localStorage.getItem('_f60_session'));

      if (!countryPicker) {
        console.error('No country picker element detected');
        return;
      }

      var countryPickerWrapper = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-wrapper'
      });
      countryPicker.appendChild(countryPickerWrapper);
      countryPickerWrapper.appendChild(this.countryPickerTrigger);
      countryPickerWrapper.appendChild(this.countryPickerMenu);

      if (this.options.currentExperience) {
        // eslint-disable-next-line prefer-destructuring
        this.currentExperience = this.options.currentExperience;
      } else if (this.session) {
        this.currentExperience = (0, _utilities.sessionToCountryObj)(this.session, this.options.countries);
      } else {
        this.currentExperience = {
          label: 'Select your country'
        };
      }

      this.countryPickerTrigger.innerHTML = "\n      ".concat((0, _utilities.getCountryFlagImageHTML)(this.currentExperience.iso_3166_2, this.options.logo, this.currentExperience.name, {
        imgSrc: this.currentExperience.logoUrl
      }), "\n      <span class=\"flow-country-picker-dropdown-trigger-text\">").concat(this.currentExperience.label ? this.currentExperience.label : this.options.labelFormatter(this.currentExperience), "</span>\n    ");
      (0, _browserHelpers.addEvent)(this.countryPickerTrigger, 'click', function () {
        return _this2.toggleDropdown();
      });
      (0, _utilities.setUpCountries)(this.options, this.session, this.generateDropdown.bind(this));
    }
  }, {
    key: "generateDropdown",

    /**
     * @param {{ countries?: CountryOption[], [key: string]: any}} result
     */
    value: function generateDropdown(result) {
      var _this3 = this;

      /** @type {import('../types').DropdownOptionsKeyValueMap} */
      var optionsMap = {};
      result.countries.forEach(
      /** @type {(country: CountryOption) => void} */
      function (country) {
        optionsMap[CountryPickerDropdown.getOptionValue(country)] =
        /** @type {DropdownOptionConfig} */
        {
          // labelFormatter is always defined as its always returned in the
          // getDefaultCountryPickerOptions response
          // @ts-ignore - lodash types broken
          label: country.label || _this3.options.labelFormatter(country),
          name: country.name,
          imgSrc: country.logoUrl,
          iso_3166_2: country.iso_3166_2
        };
      });
      var selectedCountry = (0, _find["default"])(result.countries,
      /** @type {(country: CountryOption)=> boolean } */
      function (country) {
        return country.name === _this3.currentExperience.name && country.currency === _this3.currentExperience.currency;
      });
      /** @type {DropdownOptions} */

      var countryDropdownOptions = {
        title: this.options.modalTitle,
        options: optionsMap,
        selectedKey: selectedCountry && CountryPickerDropdown.getOptionValue(selectedCountry),
        logo: this.options.logo,
        onItemSelect: function onItemSelect(_ref) {
          var value = _ref.value,
              item = _ref.item;
          _this3.countryPickerTrigger.innerHTML = "\n          ".concat((0, _utilities.getCountryFlagImageHTML)(item.iso_3166_2, _this3.options.logo, item.name, item.imgSrc), "\n          <span class=\"flow-country-picker-dropdown-trigger-text\">").concat(item.label, "</span>\n        ");

          var sessionPutForm = _this3.options.onSelection((0, _find["default"])(result.countries, function (country) {
            return CountryPickerDropdown.getOptionValue(country) === value;
          }));

          if (sessionPutForm) {
            if (!(_this3.session && _this3.session.id)) {
              console.error('You cannot use default on selection behaviour when a Flow session does not exist.');
              return;
            }

            (0, _utilities.updateSession)(sessionPutForm, _this3.session.id, _this3.session.organization, _this3.options.onSessionUpdate);
          }
        }
      };

      var countries = _dropdown_component["default"].generateDropdownOptions(countryDropdownOptions);

      countries.forEach(function (ddopt) {
        return _this3.countryPickerMenu.appendChild(ddopt);
      });
    }
  }], [{
    key: "getOptionValue",
    value: function getOptionValue(country) {
      return "".concat(country.iso_3166_3, "_").concat(country.currency);
    }
  }]);
  return CountryPickerDropdown;
}();

exports["default"] = CountryPickerDropdown;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/lib/dropdown/country-picker-dropdown.js
// module id = 539
// module chunks = 0 1